document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("index-swiper")) {
    class IndexSwiper extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector(".index-swiper-container");
        this.current_index = 0;
        this.youtube_list = this.querySelectorAll("[data-plyr-provider]");
        this.video_list=this.querySelectorAll(".shopify-lazy-common-video .common-lazy-video")
        this.size = this.dataset.size;
        this.video_btn = this.querySelectorAll(".index-swiper-btn");
        this.swiper_obj = this.querySelector(".swiper");
        this.swiper = null;
        this.player_list = [];
        this.type== this.video_list && this.video_list.length>0 ? 'video' : 'youtube'
        this.line_clamp=this.getAttribute("data-line_clamp")
        this.video_first_play=this.getAttribute("data-video_first_play")=='true'? true : false;
      }
      connectedCallback() {
        this.detectObserver();
      }
      detectObserver() {
        let height = window.innerHeight / 2;
        if (this.container) {
          const resizeObserver = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                this.initDetectVideo();
                this.initSwiper();
                this.initVideoBtnClickEvent();
                if(this.line_clamp>0){
                  this.initLineClamp()
                }
                resizeObserver.disconnect();
              }
            },
            { threshold: 0, rootMargin: `${height}px 0px 0px 0px` }
          );
          resizeObserver.observe(this.container);
        }
      }
      initDetectVideo() {
        if(this.video_list && this.video_list.length>0){
          this.player_list.push(...this.video_list)
        }
        if (!this.youtube_list) return;
        for (let item of this.youtube_list) {
          const ite = new Plyr(item, {
            controls: ["progress", "fullscreen"],
            tooltips: { controls: false, seek: false },
          });
          this.player_list.push(ite);
        }
        this.playFirstVideo();
      }
      initSwiper() {
        if (!this.swiper_obj) return;
        const slider_pc_num = this.getAttribute("data-swiper_pc_num")
          ? this.getAttribute("data-swiper_pc_num")
          : 1;
        const slider_ipad_num = this.getAttribute("data-swiper_ipad_num")
          ? this.getAttribute("data-swiper_ipad_num")
          : slider_pc_num;
        const slider_m_num = this.getAttribute("data-swiper_m_num")
          ? this.getAttribute("data-swiper_m_num")
          : slider_ipad_num;
        const prevButton = this.querySelector(".swiper-button-prev");
        const nextButton = this.querySelector(".swiper-button-next");
        const scrollbar = this.querySelector(".swiper-scrollbar");
        const pagination = this.querySelector(".swiper-pagination");
        const swiper_auto=this.getAttribute("data-swiper_auto")=='true'?true:false
        const swiper_auto_time=this.getAttribute("data-swiper_auto_time") * 1
        const loop= this.getAttribute("data-swiper_loop")=='true' ? true : false
        const speed= this.getAttribute("data-swiper_speed") * 1000
        let autoplay = false
        if(swiper_auto){
          autoplay = {
              delay: swiper_auto_time,
              stopOnLastSlide: false,
              disableOnInteraction: true,
            }
        }
        this.swiper = new Swiper(this.swiper_obj, {
          slidesPerView: slider_pc_num,
          spaceBetween: 20,
          autoplay:autoplay,
          loop:loop,
          speed: speed , 
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
          breakpoints: {
            1024: {
              spaceBetween: 15,
              slidesPerView: slider_ipad_num,
            },
            589: {
              spaceBetween: 10,
              slidesPerView: slider_m_num,
            },
          },
        });
      }
       initVideoBtnClickEvent() {
        for (let btn_item of this.video_btn) {
          let flag=btn_item.getAttribute("data-video_fullscreen") == 'true' ? true : false
          const item = btn_item.closest(".index-swiper-item");
          if (flag && item) {
            item.classList.add("fullscreen-enabled");
          }
          btn_item.addEventListener("click", () => {
            let index = btn_item.dataset.index;
            this.pauseVideoFn(this.current_index);
            this.playVideoFn(index);
            if (flag) {
              this.playVideoFn(index)
              this.player_list[index]?.fullscreen?.enter?.();
              const curItem = btn_item.closest(".index-swiper-item");
              const nativeVideo = curItem?.querySelector("video");
              if (!document.fullscreenElement && !document.webkitFullscreenElement) {
                nativeVideo?.requestFullscreen?.() || nativeVideo?.webkitEnterFullscreen?.();
              }
            }
          });
        }
      }
      playVideoFn(play_index) {
        this.current_index = play_index;
        this.video_btn[play_index].classList.add("active");
        this.video_btn[play_index]
          .closest(".index-swiper-item")
          .classList.add("active");
        this.player_list[play_index] &&
          this.player_list[play_index].paused &&
          this.player_list[play_index].play();
      }
      pauseVideoFn(pause_index) {
        this.video_btn[pause_index].classList.remove("active");
        this.video_btn[pause_index]
          .closest(".index-swiper-item")
          .classList.remove("active");
        this.player_list[pause_index] &&
          !this.player_list[pause_index].paused &&
          this.player_list[pause_index].pause();
      }
      playFirstVideo() {
        let flag=this.video_btn[0] && this.video_btn[0].getAttribute("data-video_loop") == 'true' ? true : false
        
        if (this.player_list[0] && this.type=='youtube') {
          this.player_list[0].on("ready", (event) => {
            this.player_list[0].muted = true;
            this.player_list[0].volume = 0;
            if(flag){
              this.player_list[0].loop = { active: true };
            }
            if(this.video_first_play){
              this.playVideoFn(0);
            }
          });
        }
        if(!flag) this.detectLoopVideo();
      }
      detectLoopVideo() {
        for (let item of this.youtube_list) {
          let j = +item.dataset.index;
          this.player_list[j] && this.player_list[j].on("ended", (event) => {
            this.pauseVideoFn(j);
            j + 1 < this.size &&
              this.player_list[j + 1] &&
              this.swiper.slideTo(j + 1) &&
              this.playVideoFn(j + 1);
          });
        }
      }
      initLineClamp() {
        const all_ele = this.querySelectorAll(".ellipsis-content")
        const btn_ele = this.querySelectorAll(".index-linka")
        if (!all_ele || !btn_ele) return;

        const single_h = getComputedStyle(this.querySelector(".ellipsis-content")).lineHeight.replace("px", "")
        const three_h = Math.ceil(single_h * 3)

        for (let all_item of all_ele) {
          let content_h = Math.ceil(all_item.offsetHeight)
          const parent_box = all_item.closest(".content");

          if (content_h > three_h) {
            all_item.classList.add("text-ellipsis")
          } else {
            parent_box.classList.add("no-more")
            
            const useless_btn = parent_box.querySelector(".index-linka");
            if(useless_btn) useless_btn.setAttribute("hidden", "true");
          }
        }

        for (let btn_item of btn_ele) {
          btn_item.setAttribute("aria-expanded", "false");

          btn_item.addEventListener("click", () => {
            const parent_box = btn_item.closest(".content");
            
            if (parent_box.classList.contains("active")) {
              btn_item.innerText = 'Learn More'
              btn_item.setAttribute("aria-expanded", "false");
            } else {
              btn_item.innerText = 'Learn Less'
              btn_item.setAttribute("aria-expanded", "true");
            }
            
            parent_box.classList.toggle("active")
          })
        }
      }
    }
    customElements.define("index-swiper", IndexSwiper);
  }
});
